import { AxiosRequestConfig } from "axios";
import { AxiosTransform } from "./axiosTransform";
import { RequestEnum } from "@/enums/httpEnum";
import http from "@/utils/http";

export interface CreateAxiosOptions extends AxiosRequestConfig {
  prefixUrl?: string;
  transform?: AxiosTransform;
  requestOptions?: RequestOptions;
}

export interface RequestOptions {
  // 请求参数拼接到url
  joinParamsToUrl?: boolean;
  // 格式化请求参数时间
  formatDate?: boolean;
  //  是否处理请求结果
  isTransformRequestResult?: boolean;
  // 是否显示提示信息
  isShowMessage?: boolean;
  // 成功的文本信息
  successMessageText?: string;
  // 是否显示成功信息
  isShowSuccessMessage?: boolean;
  // 是否显示失败信息
  isShowErrorMessage?: boolean;
  // 错误的文本信息
  errorMessageText?: string;
  // 是否加入url
  joinPrefix?: boolean;
  // 接口地址， 不填则使用默认apiUrl
  apiUrl?: string;
  // 错误消息提示类型
  errorMessageMode?: "none" | "modal";
}

export interface Result<T = any> {
  code: number;
  msg: string;
  data?: T;
}

export interface ResultPage<T = any> {
  code: number;
  msg: string;
  pageIndex: number;
  pageCount: number;
  pageSize: number;
  totalSize: number;
  data: T[];
}

export class ApiBase {
  //接口URL
  url?: string;
  //接口注释
  desc?: string;
  //接口请求方法，默认GET
  method?: RequestEnum;
  //请求参数的格式
  type?: "json";
  //请求的目标，目标服务的前缀
  target?: "base" | "event" | "report";
  //是否启用防抖，默认启用
  enableDebounce?: boolean = true;
}

export class Api extends ApiBase {
  headers?: any;
  params?: any;
  data?: any;

  constructor(apiObj: ApiBase) {
    super();
    for (const apiObjKey in apiObj) {
      this[apiObjKey] = apiObj[apiObjKey];
    }
  }

  request<T>(params?: any, options?: RequestOptions): Promise<Result<T>> {
    const cloneThis = JSON.parse(JSON.stringify(this));
    cloneThis.params = params;
    return http.request<Result<T>>(cloneThis, options);
  }
}
